import qs from 'qs'
import { CallApi } from '@signavio/kraken'
import { schema as schemas } from 'normalizr'

import { ADMIN_API_BASE } from '../../callApi'

export const collection = 'releasenotes'

export const schema = new schemas.Array(new schemas.Entity(collection))

const defaultRequestParams = {
  pagesize: 5,
  offset: 0,
}

type FetchRequestParamsType = {
  pagesize: number
  offset: number
}

export const fetch =
  (callApi: CallApi) =>
  (_: unknown, __: unknown, requestParams: FetchRequestParamsType) => {
    return callApi(
      `${ADMIN_API_BASE}/releasenotes${qs.stringify(
        {
          ...defaultRequestParams,
          ...requestParams,
        },
        {
          addQueryPrefix: true,
        }
      )}`,
      schema
    )
  }

export const create = (callApi: CallApi) => (_: unknown, body: object) => {
  return callApi(`${ADMIN_API_BASE}/releasenotes`, schema, {
    method: 'POST',
    body,
  })
}

export const update =
  (callApi: CallApi) =>
  ({ id }: { id: string }, body: object) => {
    return callApi(`${ADMIN_API_BASE}/releasenotes/${id}`, schema, {
      method: 'PUT',
      body,
    })
  }

export const remove =
  (callApi: CallApi) =>
  (_: unknown, { id }: { id: string }) => {
    return callApi(`${ADMIN_API_BASE}/releasenotes/${id}`, schema, {
      method: 'DELETE',
    })
  }
